import React from 'react';

const LogoWithCircle = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M5.76641 13.1751C5.07787 12.4868 5.07786 11.3708 5.7664 10.6825C6.45494 9.99421 7.57129 9.99421 8.25983 10.6825L13.2467 15.6677C13.9352 16.356 13.9352 17.472 13.2467 18.1603C12.5582 18.8486 11.4418 18.8486 10.7533 18.1603L5.76641 13.1751Z"
        fill="white"
      />
      <path
        d="M13.2469 18.1603C12.5584 18.8486 11.442 18.8486 10.7535 18.1603C10.0649 17.472 10.0649 16.356 10.7535 15.6677L15.7404 10.6825C16.4289 9.99418 17.5452 9.99418 18.2338 10.6825C18.9223 11.3708 18.9223 12.4868 18.2338 13.1751L13.2469 18.1603Z"
        fill="white"
      />
      <path
        d="M11.9955 9.10406C13.0602 9.10406 13.9232 8.24131 13.9232 7.17703C13.9232 6.11276 13.0602 5.25 11.9955 5.25C10.9309 5.25 10.0679 6.11276 10.0679 7.17703C10.0679 8.24131 10.9309 9.10406 11.9955 9.10406Z"
        fill="white"
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#F2F2F2" />
    </svg>
  );
};

export default LogoWithCircle;
